import React from 'react'
import useCSSForHeight from '../../../hook/UseCSSForHeight'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'

const Description = ({ block }) => {
    const [isActive, setIsActive] = React.useState(false)
    const ref = useCSSForHeight('description-block')
    return (
        <div className="block-description">
            <button onClick={() => setIsActive(!isActive)}>
                {icon('list')}
                Voir la version texte de l'infographie
                <div className="baseocom-icon">{icon(isActive ? 'minus' : 'plus')}</div>
            </button>

            <div
                ref={ref}
                style={{
                    maxHeight: isActive ? 'var(--' + 'description-block' + ')' : 0,
                }}
                className={`leaflet-container`}
            >
                <div className="baseocom-content">
                    {block?.childrens && <Parser content_block={block.childrens} />}
                </div>
            </div>
        </div>
    )
}

export default Description
